import { apiClient } from './apiClient';

export enum JobType {
  FULL_TIME = 'Full Time',
  PART_TIME = 'Part Time',
}

export interface JobPosting {
  id: string;
  jobId: string;
  jobTitle: string;
  jobType: JobType;
  position: string;
  jobDescriptionId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateJobPostingDto {
  jobTitle: string;
  jobType: JobType;
  position: string;
  jobDescriptionId: string;
  skills?: string;
  keyResponsibilities?: string;
}

export interface UpdateJobPostingDto {
  jobTitle?: string;
  jobType?: JobType;
  position?: string;
  jobDescriptionId?: string;
  skills?: string;
  keyResponsibilities?: string;
}

class JobPostingService {
  async getAllJobPostings(): Promise<JobPosting[]> {
    const response = await apiClient.get('/job-postings');
    return response.data;
  }

  async getJobPosting(id: string): Promise<JobPosting> {
    const response = await apiClient.get(`/job-postings/${id}`);
    return response.data;
  }

  async createJobPosting(jobPostingData: CreateJobPostingDto): Promise<JobPosting> {
    const response = await apiClient.post('/job-postings', jobPostingData);
    return response.data;
  }

  async updateJobPosting(id: string, jobPostingData: UpdateJobPostingDto): Promise<JobPosting> {
    const response = await apiClient.put(`/job-postings/${id}`, jobPostingData);
    return response.data;
  }

  async deleteJobPosting(id: string): Promise<void> {
    await apiClient.delete(`/job-postings/${id}`);
  }
}

export const jobPostingService = new JobPostingService();

